<template><div>
    <!-- <section class="hero is-fullheight is-danger">
  <div class="hero-body">
    <div class="container has-text-centered">
      <div class="title" v-html=join(stem)>

      </div>
      <div class="title">
        Anything <a href='https://en.wikipedia.org/wiki/Science,_technology,_engineering,_and_mathematics'>STEM</a>
      </div>
    </div>
  </div>
    </section> -->


    <section class="hero is-fullheight is-danger">

        <div class="hero-body">
            <div class="container" >     
                <div class="field is-grouped is-grouped-multiline">   
                    <div class="control">
                        <div class="tags has-addons" v-for='(value, key) in tags' :key='key'>
                            <a class="tag is-link is-large is-uppercase">{{key}}</a>
                            <span  v-for='tag in value' :key='tag' v-html='tag' class="tag is-primary is-large"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    <div class="hero-foot">
        <div class="container">
            <div class="tabs is-centered subtitle">
                <ul>
                  <!-- <li>stem</li><li>（科学，技术，工程，数学)</li> -->
                </ul>
            </div>
        </div>
    </div>        
    
    </section>




</div></template>

<script>
import md from "../components/mdify.vue";

export default {
  data() {
    return {
      stem: ["科学", "技术", "工程", "数学"],
      tags: {
        // 特长: [
        //   '国际化研发团队创建&成长',
        //   '产品研发项目管理',
        //   '系统设计（软件＆硬件）'
        // ],
        云平台: ["Azure", "AWS", "腾讯", "百度", "阿里云", "七牛", "又拍云"],
        IoT平台: ["BeagleBone", "Arduino", "Raspberry", "Windows 10 for IoT"],
        工业平台: ["工业 PC", "PLC", "MCS51/ARM MCU"],
        "服务器/桌面": ["Linux", "Windows"],
        工业协议: [
          "EtherCAT",
          "Profibus",
          "Sercos",
          "CAN",
          "SPI/I²C",
          "USB",
          "UART",
          "RS232/RS485"
        ],
        电子电路设计与仿真: [
          "Protel/Altium",
          "pSPice",
          "Matlab/Simulink",
          "ANSYS"
        ],
        '常用语言': ["Python", "C++", "C#", "Javascript", "Rust", "Go"],
        '机器学习工具(Python)': [
          "Anaconda",
          "Jupyter Notebook",
          "Scipy",
          "Numpy",
          "Matplotlib",
          "PANDAS"
        ],
        "C++ 库": ["Boost Library", "POCO Library", "OpenCV"],
        '前端设计库': ["Vue.js", "Dojo", "Jquery", "Bulma", "Bootstrap"],
        '开发流程工具': ["Team Foundation Server(TFS)", "Git", "Mercury", "SVN"]
        // 常用编辑器: ['Visual Studio Code', 'Typora', 'Notepad++'],
        // 日常关注: ['<a href=''>reddit</a>', 'Hacker News'],
        // Reddit关注: [
        //   'r/Art',
        //   'r/books',
        //   'r/bootstrap',
        //   'r/cpp',
        //   'r/dataisbeautiful',
        //   'r/datascience',
        //   'r/docker',
        //   'r/Documentaries',
        //   'r/explainlikeimfive',
        //   'r/Fitness',
        //   'r/gadgets',
        //   'r/javascript',
        //   'r/news',
        //   'r/philosophy',
        //   'r/Python',
        //   'r/science',
        //   'r/Ubuntu',
        //   'r/vuejs',
        //   'r/windows'
        // ]
      }
    };
  },
  methods: {
    join(items) {
      return items ? items.join(" · ") : "";
    }
  },
  // props: ["contents"],

  components: {
    md
  }
};
</script>




// WEBPACK FOOTER //
// src/components/landing_interests.vue